import * as React from 'react';
import { Close } from '@material-ui/icons';
import type InfoBannerProps from 'types/components/InfoBannerProps';
import 'styles/components/InfoBanner.scss';

export default ({ message = '', result, onClose }: InfoBannerProps): JSX.Element => {
  const [errorMessage, setErrorMessage] = React.useState('');

  const [messageColor, setMessageColor] = React.useState('');
  const [messageBackgroundColor, setMessageBackgroundColor] = React.useState('');

  const handleError = () => {
    setErrorMessage('');
    if (onClose) onClose();
  };

  React.useEffect(() => {
    setErrorMessage(message);
    const appendMsg = setTimeout(handleError, 6000);
    setMessageColor(Boolean(result) ? 'success-color' : 'error-color');
    setMessageBackgroundColor(Boolean(result) ? 'success-bg' : 'error-bg');
    return () => clearTimeout(appendMsg);
  }, [message]);

  return (
    <div className={`Banner--hero ${Boolean(errorMessage) ? 'show' : ''} ${messageBackgroundColor}`}>
      <p className={`Banner--msg ${messageColor}`}>{message}</p>
      <Close onClick={handleError} className={`Banner--close-icon ${messageColor}`} />
    </div>
  );
};
